import styled from 'styled-components'
import { H30M, TextBody } from 'src/styles/Typography'
import { StyledButton } from 'src/styles/Button'

const OptionCard = ({
  heading,
  summary,
  selected = false,
  image = false,
  handleClick,
  value,
  name,
  design = 'a',
  ...rest
}) => {
  if (design === 'b') {
    return (
      <StyledButton
        type="button"
        value={value}
        onClick={handleClick}
        selected={selected}
        name={name}
        size="large"
        {...rest}
      >
        {heading}
      </StyledButton>
    )
  }

  return (
    <OptionCardContainer
      type="button"
      value={value}
      onClick={handleClick}
      selected={selected}
      name={name}
    >
      {image && <ImagePlaceholder />}
      {heading && <H30M>{heading}</H30M>}
      {summary && <TextBody>{summary}</TextBody>}
    </OptionCardContainer>
  )
}

const ImagePlaceholder = styled.div`
  width: 48px;
  height: 48px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
`

const OptionCardContainer = styled.button`
  --optionCard-width: 100%;
  --optionCard-height: auto;
  --optionCard-padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: var(--optionCard-width);
  height: var(--optionCard-height);
  padding: var(--optionCard-padding);
  border-radius: 5px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
  background: white;
  transition: box-shadow 0.2s ease-in-out;
  cursor: pointer;
  outline: unset;
  border: ${({ selected }) => (selected ? '4px solid #03A0CE' : 'unset')};
  // TODO: fix border is effecting spacing of the card

  ${TextBody} {
    font-family: 'Libre Baskerville';
  }

  > * {
    margin: 0.5rem auto;
    // For some reason things inside the button are preventing click
    pointer-events: none;
  }

  &:hover,
  &:focus {
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1), 0px 3px 6px rgba(0, 0, 0, 0.06);
  }
`

export default OptionCard
